import api from '@zimpel/common/newApi';
import type { Request } from '@zimpel/common/api/types';

export type LoginParams = { username: string; password: string; };
export type LoginResponse = {
  redirectPath: string
};

export const login: Request<LoginParams, LoginResponse> = ({ username, password }) => api
  .post('/account_session', { account_session: { username, password } }); // eslint-disable-line @typescript-eslint/naming-convention

export type ResetPasswordParams = { username: string; };
export type ResetPasswordResponse = null;

export const resetPassword: Request<ResetPasswordParams, ResetPasswordResponse> = ({ username }) => api
  .post('/api/password_resets', { username });

export type UpdatePasswordParams = { password: string; passwordConfirmation: string, token: string };
export type UpdatePasswordResponse = null;

export const updatePassword: Request<UpdatePasswordParams, UpdatePasswordResponse> = ({ password, passwordConfirmation, token }) => (
  // eslint-disable-next-line @typescript-eslint/naming-convention
  api.patch(`/api/password_resets/${token}`, { password, password_confirmation: passwordConfirmation })
);
